import * as moment from 'moment';
import { EventFilter } from 'types/events';
import { createStandardAction } from 'typesafe-actions';

const CHANGE_DATE = 'events/CHANGE_DATE';
const SEARCH_REQUEST = 'events/SEARCH_REQUEST';
const SEARCH = 'events/SEARCH';
const UPDATE_FILTER = 'events/UPDATE_FILTER';
const SET_COUNTRY_FILTER = 'events/SET_COUNTRY_FILTER';

export interface IChangeDatePayload {
  date: moment.Moment;
}

export const changeDate = createStandardAction(CHANGE_DATE)<
  IChangeDatePayload
>();

export interface ISearchPayload {
  type: 'country' | 'event';
  text: string;
}

export const search = createStandardAction(SEARCH)<ISearchPayload>();

export const searchRequest = createStandardAction(SEARCH_REQUEST)<
  ISearchPayload
>();

export interface IChangeFilterPayload {
  filter: EventFilter;
}

export const changeFilter = createStandardAction(UPDATE_FILTER)<
  IChangeFilterPayload
>();

export interface ISetCountryFilterPayload {
  country: string;
  label: string;
}

export const setCountry = createStandardAction(SET_COUNTRY_FILTER)<
  ISetCountryFilterPayload
>();



// WEBPACK FOOTER //
// ./src/store/modules/events/actions.ts